module.exports = __webpack_public_path__ + "static/media/MacBook.5d7e3177.svg";